import { createEntityAdapter } from '@reduxjs/toolkit';
import { ClientParams } from './clients.types';

const adapter = createEntityAdapter<ClientParams>();

export default adapter;
